// What a ticket form still needs, in one place, so every form warns the same way.
// must: cannot be saved like this. should: the office and the tech will need it, the person can still save without it.
export interface TicketGaps { must: string[]; should: string[]; }

export function ticketGaps(f: any, customers: any[] = []): TicketGaps {
  const must: string[] = []; const should: string[] = [];
  const has = (v: any) => String(v ?? '').trim() !== '';
  if (!has(f.title)) must.push('Title');
  if (has(f.contact_email) && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(f.contact_email).trim())) must.push('Contact email (not a valid address)');
  if (has(f.scheduled_start) && has(f.scheduled_end) && new Date(f.scheduled_end) < new Date(f.scheduled_start)) must.push('Scheduled end (it is before the start)');
  const cust = customers.find((c) => c.id === f.customer_id);
  if (!f.customer_id) should.push('Customer');
  if (!has(f.contact_name)) should.push('Contact Name');
  if (!has(f.contact_phone)) should.push('Contact Phone');
  if (!has(f.service_address_line1) && !has(f.service_city) && !(cust && (has(cust.address_line1) || has(cust.city)))) should.push('Service address');
  if (f.assigned_to_id && !has(f.scheduled_start)) should.push('Scheduled start');
  return { must, should };
}
